import { render } from "./absen-list-custom.vue?vue&type=template&id=20897a91"
import script from "./absen-list-custom.vue?vue&type=script&lang=js"
export * from "./absen-list-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__